import { PropsWithChildren, createContext, useMemo } from "react";

import { InputChoiceContextValue } from "./InputChoiceContext.decl";

export const InputChoiceContext = createContext<InputChoiceContextValue | null>(
  null
);

export function InputChoiceContextProvider({
  isSelected,
  isDisabled,
  children,
}: PropsWithChildren<InputChoiceContextValue>) {
  const contextValue = useMemo(
    () => ({ isSelected, isDisabled }),
    [isSelected, isDisabled]
  );

  return (
    <InputChoiceContext.Provider value={contextValue}>
      {children}
    </InputChoiceContext.Provider>
  );
}
